import React from "react";
import { useTranslation } from "react-i18next";
import { Alert } from "@material-ui/lab";
import { NavLink } from "react-router-dom";
import { getServiceNameWithNickname } from "../../../../utils/getServiceNameWithNickname";
import PageSpinner from "../../../elements/spinner/PageSpinner";

import {
  StyledCol,
  StyledScrollTable,
  StyledTable,
  StyledTableBody,
  StyledTableHead,
  StyledTableRow
} from "../../../styles/styledTable";
import { StyledBreakWord } from "../../../styles/styledBreakWord";

const RateList = ({ rates }) => {
  const { t } = useTranslation("ratesPage");

  if (!rates) {
    return <PageSpinner
      position="center"
      pt="20"
      pb="20"
    />;
  }

  if (rates.length === 0) {
    return <Alert severity="warning">{t("rates.table.emptyData")}</Alert>;
  }

  return (
    <StyledScrollTable>
      <StyledTable
        width="1280"
        size="14"
      >
        <StyledTableHead
          className="rates-table__head"
          scroll="auto"
          col="9"
        >
          <div>
            {t("rates.table.currency")}
          </div>
          <div>
            {t("rates.table.service")}
          </div>
          <div>
            {t("rates.table.rateSelling")}
          </div>
          <div>
            {t("rates.table.ratePurchase")}
          </div>
          <div>
            {t("rates.table.selling")}, %
          </div>
          <div>
            {t("rates.table.purchase")}, %
          </div>
          <div>
            {t("rates.table.rateBaseService")}
          </div>
          <div>
            {t("rates.table.project")}
          </div>
          <div>
            {t("rates.table.action")}
          </div>
        </StyledTableHead>
        <StyledTableBody>
          {rates && rates.map((value, key) => (
            <StyledTableRow
              key={key}
              scroll="auto"
              col="9"
            >
              <StyledCol>
                {value.rateBase.currency.asset}
              </StyledCol>
              <StyledCol>
                {getServiceNameWithNickname(value.connection.service.name, value.connection.service.nickname)}
              </StyledCol>
              <StyledCol inline>
                <StyledBreakWord as="p">
                  {value.selling}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol inline>
                <StyledBreakWord as="p">
                  {value.purchase}
                </StyledBreakWord>
              </StyledCol>
              <StyledCol>
                {value.cleanSelling}
              </StyledCol>
              <StyledCol>
                {value.cleanPurchase}
              </StyledCol>
              <StyledCol>
                {getServiceNameWithNickname(value.rateBase.service.name, value.rateBase.service.nickname)}
              </StyledCol>
              <StyledCol>
                {value.connection.project.name}
              </StyledCol>
              <StyledCol inline>
                <NavLink
                  className="table-action table-action_info"
                  to={"/clients/rate/" + value.id}
                >
                  <span className="icon-light-edit" />
                  {t("rates.table.edit")}
                </NavLink>
              </StyledCol>
            </StyledTableRow>
          ))}
        </StyledTableBody>
      </StyledTable>
    </StyledScrollTable>
  );
};
export default RateList;